export default "__VITE_ASSET__d4194d5b__"